<template>
  <div class="tutorial-list">
    <md-button class="md-icon-button close-button" @click="onClose">
      <md-icon>close</md-icon>
    </md-button>
    <div class="title-container">
      <span class="title" size="24px">
        Video Tutorials: {{ categoryLabel }}
      </span>
      <md-divider />
    </div>
    <md-divider />

    <div class="accordion">
      <div
        v-for="(tutorial, index) in tutorials"
        :key="tutorial._id"
        class="tutorial-item"
      >
        <div class="accordion-item">
          <md-button
            class="md-raised accordion-trigger"
            :class="{ open: isActivePanel(tutorial._id) }"
            @click="toggleActivePanel(tutorial._id)"
          >
            <label>{{ index + 1 }}. {{ tutorial.title }}</label>
            <md-icon class="trigger-icon">arrow_right</md-icon>
          </md-button>
        </div>
        <transition name="fold">
          <div v-if="isActivePanel(tutorial._id)" class="accordion-content">
            <vue-vimeo-player :video-id="tutorial.mediaId" :options="{ portrait: false}" />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { vueVimeoPlayer } from 'vue-vimeo-player'

export default {
  name: 'tutorial-list',
  components: {
    vueVimeoPlayer
  },
  props: {
    category: {
      type: String,
      default: null,
    },
    productType: {
      type: String,
      default: 'EMS'
    },
  },
  data() {
    return {
      categoryLabels: {
        'SCENARIO_BUILDER': { en: 'Scenario Builder' },
        'SCENARIO_SELECT': { en: 'Scenario Select' },
        'SCENARIO_LOGIC': { en: 'Scenario Logic' },
        'ORG_MANAGEMENT': { en: 'Org Management' },
      },
      state: {
        activeAccordionPanel: null,
      },
    };
  },
  computed: {
    ...mapGetters('tutorials', {
      tutorialsMap: 'getTutorialsMap',
    }),
    categoryLabel() {
      return this.category ? this.categoryLabels[this.category].en : null;
    },
    tutorials() {
      return this.category ? this.tutorialsMap[this.category] : [];
    },
  },
  watch: {
    tutorials() {
      this.initializeActivePanel();
    }
  },
  mounted() {
    this.fetchTutorials({
      category: this.category,
      productType: this.productType
    });
    this.initializeActivePanel();
  },
  methods: {
    ...mapActions('tutorials', ['fetchTutorials']),
    isActivePanel(panel) {
      return this.state.activeAccordionPanel === panel;
    },
    toggleActivePanel(panel) {
      if (this.isActivePanel(panel)) {
        this.state.activeAccordionPanel = null;
      } else {
        this.state.activeAccordionPanel = panel;
      }
    },
    initializeActivePanel() {
      if (this.tutorials && this.tutorials.length) {
        this.state.activeAccordionPanel = this.tutorials[0]._id;
      }
    },
    onClose() {
      this.$emit('close');
    },
  }
}
</script>

<style scoped>
.close-button {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.title-container {
  padding: 30px;
}

.title-container .md-divider {
  margin-top: 8px;
  height: 2px;
  background-color: black;
}

.title {
  font-size: 24px;
  font-weight: 600;
}

.accordion {
  width: 100%;
}

.accordion-item {
  display: flex;
  flex-direction: column;
}

.accordion-item .md-button {
  border-radius: 0;
  padding: 10px;
  font-size: 16px;
  text-transform: none;
}

.accordion-trigger {
  margin: 0;
  text-align: left;
  height: 60px;
  z-index: 3;
}
.accordion-trigger.open .trigger-icon {
  transform: rotateZ(90deg);
  margin: unset;
}
.accordion-trigger label {
  flex: 1;
  padding-left: 10px;
}

.accordion-trigger >>> .md-button-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 6px;
  align-items: center;
}

.accordion-content {
  margin-bottom: 15px;
  height: 360px;
}

.accordion-content >>> iframe {
  height: 360px;
}

.fold-enter-active,
.fold-leave-active {
  transition: max-height 0.5s;
}
.fold-enter, .fold-leave-to /* .fade-leave-active below version 2.1.8 */ {
  max-height: 0;
}

.fold-enter-to,
.fold-leave {
  max-height: 300px;
}
</style>